/**
 * Environment Configuration Utility
 * 
 * This utility determines which features are available in different environments.
 * Admin panel features (solution builder, pipeline runner, custom deployments) 
 * should only be available in the sandbox environment.
 */

// Get the current environment from environment variable
export const getCurrentEnvironment = () => {
  return process.env.REACT_APP_LAMBDA_ENV || 'dev';
};

// Check if current environment is sandbox (base branch)
export const isSandboxEnvironment = () => {
  return getCurrentEnvironment() === 'sandbox';
};

// Check if current environment is a deployment target (not sandbox)
export const isDeploymentTarget = () => {
  const deploymentTargets = ['datalakenv', 'dev', 'qa', 'stage', 'preprod', 'prod'];
  return deploymentTargets.includes(getCurrentEnvironment());
};

// Feature flags based on environment
export const features = {
  // Admin panel features - only in sandbox
  adminPanel: isSandboxEnvironment(),
  solutionBuilder: isSandboxEnvironment(),
  customDeployments: isSandboxEnvironment(),
  pipelineRunner: isSandboxEnvironment(),
  environmentOverview: isSandboxEnvironment(),
  stackRecommender: isSandboxEnvironment(),
  
  // Features available in all environments
  dashboard: true,
  solutions: true,
};

// Get admin panel menu items based on environment
export const getAdminMenuItems = () => {
  if (!isSandboxEnvironment()) {
    return [];
  }
  
  return [
    { id: 'edit-modules', label: 'UI Configuration', path: '/admin/edit-modules' },
    { id: 'stack-recommender', label: 'Stack Recommender', path: '/admin/stack-recommender' },
    { id: 'environment-overview', label: 'Environment Overview', path: '/admin/environment-overview' },
    { id: 'custom-solution-builder', label: 'Custom-built Solution', path: '/admin/custom-solution-builder' },
    { id: 'custom-deployments', label: 'Custom Deployments', path: '/admin/custom-deployments' }
  ];
};

// Log environment configuration on load
console.log('Environment Configuration:', {
  environment: getCurrentEnvironment(),
  isSandbox: isSandboxEnvironment(),
  features: features
});
